/* eslint-disable react/function-component-definition, react/destructuring-assignment, react/prop-types */
import React, { useMemo, useState, useEffect } from "react";
import { Checkbox } from "../Checkbox";
import styles from "./Table.scss";

function Selection(props) {
  const { checked, disabled, indeterminate } = props; // eslint-disable-line react/prop-types
  return (
    <Checkbox
      readOnly
      checked={checked}
      disabled={disabled}
      indeterminate={indeterminate}
    />
  );
}

const selectionRenderer =
  (loading) =>
  ({ disabled, ...rest }) =>
    <Selection {...rest} disabled={disabled || loading} />;

const onSelect =
  ({ keyField, externalOnSelect, selectedData, setSelectedData }) =>
  (row, isSelect) => {
    const result = isSelect
      ? selectedData.concat(row)
      : selectedData.filter((item) => item[keyField] !== row[keyField]);

    setSelectedData(result);
    externalOnSelect(result);
  };

const onSelectAll =
  ({ externalOnSelect, setSelectedData }) =>
  (isSelect, rows) => {
    const result = isSelect ? rows : [];

    setSelectedData(result);
    externalOnSelect(result);
  };

const useSelectRow = ({
  keyField,
  externalOnSelect,
  selected,
  loading,
  readOnly,
}) => {
  const [selectedData, setSelectedData] = useState([]);

  const result = useMemo(
    () => ({
      selected: selectedData.map((item) => item[keyField]),
      onSelect: onSelect({
        keyField,
        externalOnSelect,
        selectedData,
        setSelectedData,
      }),
      onSelectAll: onSelectAll({ externalOnSelect, setSelectedData }),
      mode: "checkbox",
      classes: styles.selected,
      selectionRenderer: selectionRenderer(loading),
      selectionHeaderRenderer: selectionRenderer(loading),
    }),
    [selectedData, keyField, externalOnSelect, loading]
  );

  useEffect(() => {
    if (selected) {
      setSelectedData(selected);
    }
  }, [selected]);

  // for the row selection to be enabled user has to pass onSelect to Table
  return !readOnly && externalOnSelect ? result : undefined;
};

export default useSelectRow;
